var _style, _polygon, _rect, _polygon2, _rect2, _path, _path2, _path3, _path4, _polygon3, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcelandairLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Content",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2300 600",
    style: {
      enableBackground: "new 0 0 2300 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#001B71;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "961.1,275 910.9,275 910.9,425 951.4,425 951.4,325.5 952,324.8 1040.9,425 1076.6,425 1076.6,275  1036.1,275 1036.1,358.6 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1486.9,
    y: 275,
    className: "st0",
    width: 45.6,
    height: 149.9
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "567,425 567,275 612.3,275 612.3,389.6 684.5,389.6 684.5,425 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 146.9,
    y: 275,
    className: "st0",
    width: 46.4,
    height: 149.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1694.4,368c20.4-7.9,32.5-21.3,32.5-45.7c0-31.2-25.2-47.3-58.3-47.3h-101v150h45.6v-53.8h36.8l32,53.7h48 L1694.4,368z M1661.1,342.4h-48v-37.9h45.6c19.9,0,25.3,8.8,25.3,19.2C1684,335.6,1675.3,342.4,1661.1,342.4L1661.1,342.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1189.9,275h-78.3v150h79.2c56.9,0,83.7-32.3,83.7-75C1274.5,303.5,1245.3,275,1189.9,275z M1184.2,391.8H1157 v-84.2h27.3c30.4,0,43.8,12.9,43.8,42.3C1228.1,377.4,1217.2,391.9,1184.2,391.8L1184.2,391.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1399.2,275h-51.4l-67.4,150h42.7l13-28.8h75.1l12.9,28.8h42.8L1399.2,275z M1349.1,367.4l24.6-60.2l24.6,60.2 H1349.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M823.2,275h-51.4l-67.4,150h42.7l13-28.8h75.1l12.9,28.8h42.8L823.2,275z M773,367.4l24.7-60.2l24.6,60.2H773z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "393.8,425 393.8,275 534.4,275 534.4,306.1 439,306.1 439,333.5 509.4,333.5 509.4,364.4 439,364.4  439,393.2 535,393.2 535,425 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.5,373.5c-9,12.8-24.8,18.7-41.8,18.7c-25.3,0-41.3-19-41.3-42.4s16-42.1,41.3-42.1 c15.6,0,32,6.4,41.5,18.9c0.1,0.2,23.9-27,23.9-27c-16.7-16.9-40.5-28.2-65.4-28.2c-47.2,0-82.4,35.2-82.4,78.6s35.2,78.6,82.4,78.6 c25.7,0,48.5-11.3,65.2-28.6C368.9,400,345.6,373.4,345.5,373.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2082.4,100l-352.5,400h345.7l124.2-400L2082.4,100z M1950,424.6c-5.6,0.7-11.2,1-16.8,0.9 c-8.6-0.1-14-1.2-18.1-2.8c-3.5-1.4-6.6-5.2-5.5-8.1c1-2.2,2.6-4.1,4.8-5.3c10.1-6.5,28.3-9.9,48.4-11.2 C1961,402,1950,424.6,1950,424.6z M2057,372.1c-14.6,17.2-29,18.4-57.4,15.8c-74.6-6.6-89,14-91.4,16.6c0.5-1.9,1.1-3.8,2-5.5 c4.7-10.7,10.4-22.6,16.8-36.8c3.6-7.4,5.6-7.7,8.9-10.1c13.5-8.9,35.2-17.2,64.1-14.7c21.3,1.9,30.6,6.2,43.7,6.9 c5.6,0.4,11.2,0.1,16.7-0.9c14-3,17.6-7.2,17.6-7.2S2068,358,2057,372.1z M2074.1,327c-4.6,2.7-10.6,5.3-22.2,5.7 c-12.8,0.4-20.6-2.4-34.7-4.7c-19.3-3.1-38-4.3-58.2,2.1c-8.6,2.7-16.7,7-23.8,12.6c0,0,14.9-33.5,18.8-42.1 c6.4-13.1,27.7-22.5,55.7-22.2c25.2,0.3,36.5,6.8,57.2,7.1c30.9-0.1,41.1-10.4,41.1-10.4c-1.8,3.8-11.2,23.5-15.6,31.9 C2085.1,318.4,2079.9,323.6,2074.1,327z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcelandairLogo);
export default __webpack_public_path__ + "static/media/icelandairLogo.ded63f388edc004490f5def982da3761.svg";
export { ForwardRef as ReactComponent };